"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var countryCodeToUnicode = function countryCodeToUnicode(countryCode) {
  var countryCodeUpperCase = countryCode.toUpperCase();
  return countryCodeUpperCase.replace(/./g, function (_char) {
    return String.fromCodePoint(_char.charCodeAt(0) + 127397);
  });
};

var _default = countryCodeToUnicode;
exports["default"] = _default;
//# sourceMappingURL=countryCodeToUnicode.js.map